import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-form-section-card',
    templateUrl: './form-section-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormSectionCardComponent {
    @Input() eyebrow = '';
    @Input() title = '';
    @Input() description = '';
    @Input() compact = false;
    @Input() fillHeight = false;
    @Input() headerInline = false;
}
